import {
  Types,
  DataTypes,
  MotivosAfastamentosActionTypes,
  MotivoAfastamentoAddOrEditDTO,
} from "./types";
import customToast from "~/components/Toast/index";
/**
 * Reducers
 */
const INITIAL_STATE: DataTypes = {
  data: [],
  loadingData: false,
  loadingAction: false,
  success: false,
  error: false,
  itemSelected: {
    item: null,
    error: false,
    loading: false,
    success: false,
  },
};

/**
 * Actions
 */

export const Creators = {
  getMotivosAfastamentos: (): MotivosAfastamentosActionTypes => {
    return {
      type: Types.REQUEST_LOAD_MOTIVOS_AFASTAMENTOS,
    };
  },

  getMotivoAfastamentoById: (
    idMotivoAfastamento: number
  ): MotivosAfastamentosActionTypes => ({
    type: Types.REQUEST_LOAD_MOTIVO_AFASTAMENTO_BY_ID,
    idMotivoAfastamento,
  }),

  addMotivoAfastamento: (
    motivo: MotivoAfastamentoAddOrEditDTO
  ): MotivosAfastamentosActionTypes => ({
    type: Types.REQUEST_ADD_MOTIVO_AFASTAMENTO,
    payload: motivo,
  }),

  editMotivoAfastamento: (
    motivo: MotivoAfastamentoAddOrEditDTO
  ): MotivosAfastamentosActionTypes => ({
    type: Types.REQUEST_EDIT_MOTIVO_AFASTAMENTO,
    payload: motivo,
  }),

  delMotivoAfastamento: (
    idMotivoAfastamento: number
  ): MotivosAfastamentosActionTypes => ({
    type: Types.REQUEST_DEL_MOTIVO_AFASTAMENTO,
    idMotivoAfastamento,
  }),
};

export default function motivoAfastamentosReducer(
  state = INITIAL_STATE,
  action: MotivosAfastamentosActionTypes
): DataTypes {
  switch (action.type) {
    // LOAD
    case Types.REQUEST_LOAD_MOTIVOS_AFASTAMENTOS:
      return {
        ...state,
        loadingData: true,
        error: false,
        success: false,
        itemSelected: { ...state.itemSelected, item: null },
      };
    case Types.SUCCESS_LOAD_MOTIVOS_AFASTAMENTOS:
      return {
        ...state,
        loadingData: false,
        error: false,
        success: true,
        data: action.payload,
      };
    case Types.FAILURE_LOAD_MOTIVOS_AFASTAMENTOS:
      customToast.error(action.message);
      return {
        ...state,
        data: [],
        loadingData: false,
        success: false,
        error: true,
      };

    //LOAD BY ID
    case Types.REQUEST_LOAD_MOTIVO_AFASTAMENTO_BY_ID:
      return {
        ...state,
        itemSelected: {
          item: null,
          loading: true,
          success: false,
          error: false,
        },
      };
    case Types.SUCCESS_LOAD_MOTIVO_AFASTAMENTO_BY_ID:
      return {
        ...state,
        itemSelected: {
          item: action.payload,
          loading: false,
          success: true,
          error: false,
        },
      };
    case Types.FAILURE_LOAD_MOTIVO_AFASTAMENTO_BY_ID:
      customToast.error(action.message);
      return {
        ...state,
        itemSelected: {
          item: null,
          loading: false,
          success: false,
          error: true,
        },
      };

    // ADD
    case Types.REQUEST_ADD_MOTIVO_AFASTAMENTO:
      return { ...state, loadingAction: true, error: false, success: false };
    case Types.SUCCESS_ADD_MOTIVO_AFASTAMENTO:
      return {
        ...state,
        loadingAction: false,
        error: false,
        success: true,
        data: [...state.data, action.payload],
      };
    case Types.FAILURE_ADD_MOTIVO_AFASTAMENTO:
      customToast.error(action.message);
      return {
        ...state,
        loadingAction: false,
        success: false,
        error: true,
      };

    // EDIT
    case Types.REQUEST_EDIT_MOTIVO_AFASTAMENTO:
      return { ...state, loadingAction: true, error: false, success: false };
    case Types.SUCCESS_EDIT_MOTIVO_AFASTAMENTO:
      return {
        ...state,
        loadingAction: false,
        error: false,
        success: true,
        data: state.data.map((item) => {
          if (item.idMotivoAfastamento === action.payload.idMotivoAfastamento) {
            return action.payload;
          }
          return item;
        }),
      };
    case Types.FAILURE_EDIT_MOTIVO_AFASTAMENTO:
      customToast.error(action.message);
      return {
        ...state,
        loadingAction: false,
        success: false,
        error: true,
      };

    // // DEL
    case Types.REQUEST_DEL_MOTIVO_AFASTAMENTO:
      return { ...state, error: false, success: false };
    case Types.SUCCESS_DEL_MOTIVO_AFASTAMENTO:
      return {
        ...state,
        error: false,
        success: true,
        data: state.data.filter(
          (item) => item.idMotivoAfastamento !== action.idMotivoAfastamento
        ),
      };
    case Types.FAILURE_DEL_MOTIVO_AFASTAMENTO:
      customToast.error(action.message);
      return {
        ...state,
        success: false,
        error: true,
      };

    default:
      return state;
  }
}
